import React, { useState, useEffect } from "react";

const CountdownTimer = ({ targetDate, t }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval] && interval == "hours") {
      return;
    }

    timerComponents.push(
      <span key={interval} className="timer-segment">
        {String(timeLeft[interval]).padStart(2, "0")}
        <span className="timer-label">{t[interval]}</span>
      </span>
    );
  });

  return (
    <div className="countdown-timer">
      {timerComponents.length ? (
        <div className="timer-display">{timerComponents}</div>
      ) : (
        <span className="timer-expired">{t.time_is_up}</span>
      )}
    </div>
  );
};

export default CountdownTimer;
